import React, { useCallback, useState } from 'react'
// import React, { useCallback, useEffect, useState } from 'react'
import { default as cn } from 'classnames'
import PropTypes from 'prop-types'
import { Track } from 'services/analytics'
import { db, callApi } from 'services/config'
import { Row, Col } from 'components/grid'
import styles from './style.scss'
import { log } from 'services/util/log'

const StateLabel = ({ state, errorMessage, successMessage }) => (
  <label className="state-label" htmlFor="email">
    {state === 'NORMAL' && <></>}
    {state === 'SUCCESS' && <>{successMessage}</>}
    {state === 'ERROR' && (
      <>
        <i className="fa fa-exclamation-circle"></i>
        {errorMessage || 'Please enter a valid email'}
      </>
    )}
  </label>
)

export const EmailCollect = ({ modal, onSuccess }) => {
  const [blurred, setBlurred] = useState(false)
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const submitEmail = useCallback(
    async e => {
      e.preventDefault()
      setSuccess(false)

      try {
        await callApi('POST', '/newsletter', null, { email })

        setSuccess(true)
        Track.newsletterSignupSubmitted(email)
        onSuccess && onSuccess()
      } catch (err) {
        log('Failed to subscribe to newsletter', null, { error: err })
        setError(`${err}`)
      }
    },
    [email]
  )

  const emailValid = email.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$/)

  const lifted = email === '' ? '' : 'lifted'

  const labelState = (() => {
    if (success) {
      return 'SUCCESS'
    } else if (!blurred) {
      return 'NORMAL'
    } else if ((blurred && !emailValid) || error) {
      return 'ERROR'
    } else {
      return 'NORMAL'
    }
  })()

  return (
    <form
      className={cn('newsletter-form-temp', {
        invalid: (blurred && !emailValid) || error,
        'modal-style': modal,
      })}
      onSubmit={submitEmail}
      data-cy="newsletter-form">
      <input
        type="email"
        name="email"
        value={email}
        required
        onChange={e => {
          e.preventDefault()
          setError('')
          setSuccess(false)
          setEmail(e.target.value)
        }}
        onBlur={e => {
          e.preventDefault()
          setBlurred(true)
        }}
      />
      <label className={cn('placeholder-label', { lifted: lifted })} htmlFor="email">
        Email*
      </label>
      <StateLabel state={labelState} errorMessage={error} successMessage="Thanks for signing up" />
      <button type="submit" disabled={blurred && !emailValid} className="NEW__btn NEW__btn--dark">
        SIGN UP
      </button>
      <style jsx global>
        {styles}
      </style>
    </form>
  )
}

export const EmailCollectWrapper = props => {
  const { customClass, modal, onSuccess } = props

  return (
    <section className={`email-capture mb-3 ${customClass}`}>
      <Row align="center">
        <Col sm="6">
          <p className="vertical-center body-text-lg text-center mbx-3">
            Want more exclusive content?
            <br /> Register for the AEDITION newsletter.
          </p>
        </Col>
        <Col sm="6">
          <EmailCollect modal={modal} onSuccess={onSuccess} />
        </Col>
      </Row>
    </section>
  )
}

EmailCollectWrapper.propTypes = {
  customClass: PropTypes.string,
  modal: PropTypes.bool,
}
